import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pickingExceptionBannerTitle: {
    defaultMessage: 'This order could not be picked.',
    description: 'Title for picking exception banner',
    id: 'Gv55tF',
  },
  pickingExceptionBannerDescription: {
    defaultMessage: "Review the reported issue in the order's items list. When you've resolved this issue, you can remove the hold.",
    description: 'Description for picking exception banner',
    id: '3qJ9d6',
  },
});
